import { defineStore } from 'pinia';

// Shared state of the agent phone, so the Calls page (and later contact pages)
// can ask the phone to dial and know whether calling is set up for this account.
export const useRelayVoicePhoneStore = defineStore('relayVoicePhone', {
  state: () => ({
    enabled: false,
    connected: false,
    inCall: false,
    open: false,
    access: { all_calls: false, call_notes: false, outcomes: [] },
    dialRequest: null,
    historyRevision: 0,
  }),

  actions: {
    requestDial(number) {
      this.open = true;
      this.dialRequest = { number, at: Date.now() };
    },
    takeDialRequest() {
      const request = this.dialRequest;
      this.dialRequest = null;
      return request;
    },
    callEnded() {
      this.historyRevision += 1;
    },
  },
});
